import { EventEmitter, Injectable } from '@angular/core';
import {
  HttpClient,
  HttpParams
} from '@angular/common/http';
import { PerfilamientoMasterRespuestasPadre } from 'src/app/models/perfilamientoMasters/perfilamientoMasterRespuestaPadre';
import { Observable } from 'rxjs';
import { HttprService } from 'src/app/shared/httpr.service';
import { PerfilamientoMasterRespuestasHijas } from 'src/app/models/perfilamientoMasters/perfilamientoMasterRespuestasHija';
import { PerfilamientoMaster } from 'src/app/models/perfilamientoMasters/perfilamientoMaster';
// import { Prospecto } from 'src/app/models/cierre';
import { PerfilamientoMasterComparativo } from 'src/app/models/perfilamientoMasters/perfilamientoMasterComparativo';
import { PerfilamientoMasterProcesosSeguimiento } from 'src/app/models/perfilamientoMasters/perfilamientoMasterProcesosSeguimiento';
import { Proyecto } from 'src/app/models/proyecto';
import { Prospecto } from 'src/app/models/prospectos';


@Injectable({ providedIn: 'root' })
export class PerfilamientoMasterService {

  prospecto = new Prospecto();
  closeEmit = new EventEmitter<string>();
  proyectoSeleccionadoPerfilamiento = new Proyecto();
  valorRecibido: string;

  constructor(private http: HttpClient,private httpr: HttprService) { }

  getProspectoPerfilamientoMaster(){
    return this.prospecto;
  }
  getProyectoSeleccionadoPerfilamiento(){
    return this.proyectoSeleccionadoPerfilamiento;
  }

  getValorRecibido(){
    return this.valorRecibido;
  }

  recuperaPerfilamientoMasterRespuestasPadre(perfilamientoMasterRespuestasPadre = new PerfilamientoMasterRespuestasPadre()) {
    return this.httpr.POST<PerfilamientoMasterRespuestasPadre[]>("/perfilamientoMaster/recuperaPerfilamientoMasterRespuestasPadre", perfilamientoMasterRespuestasPadre);
  }

  recuperaPerfilamientoMasterRespuestasHijas(perfilamientoMasterRespuestasHijas = new PerfilamientoMasterRespuestasHijas()) {
    return this.httpr.POST<PerfilamientoMasterRespuestasHijas[]>("/perfilamientoMaster/recuperaPerfilamientoMasterRespuestasHijas", perfilamientoMasterRespuestasHijas);
  }

   guardaPerfilamientoMaster(perfilamientoMaster = new PerfilamientoMaster()) {
    return  this.httpr.POST<PerfilamientoMaster[]>("/perfilamientoMaster/guardaPerfilamientoMaster", perfilamientoMaster);
  }

  guardaPerfilamientoMasterRespuestaHijas(perfilamientoMasterRespuestasHijas = new PerfilamientoMasterRespuestasHijas()){
    return this.httpr.POST<PerfilamientoMaster[]>("/perfilamientoMaster/guardaPerfilamientoMasterRespuestasHijas", perfilamientoMasterRespuestasHijas);
  }

  guardaPerfilamientoMasterRespuestaPadres(perfilamientoMasterRespuestasPadres = new PerfilamientoMasterRespuestasPadre()){
    return this.httpr.POST<PerfilamientoMaster[]>("/perfilamientoMaster/guardaPerfilamientoMasterRespuestasPadres", perfilamientoMasterRespuestasPadres);
  }

  recuperaPerfilamientoMasterProspectos(perfilamientoMaster = new PerfilamientoMaster()): Observable<Prospecto> {
    return this.httpr.POST<Prospecto>("/perfilamientoMaster/recuperaPerfilamientoMasterProspectos", perfilamientoMaster);
  }

  removerInteresPerfilamientoMaster(perfilamientoMaster = new PerfilamientoMaster()): Observable<Prospecto> {
    return this.httpr.POST<Prospecto>("/perfilamientoMaster/removerInteresPerfilamientoMaster", perfilamientoMaster);
  }

  recuperaPerfilamientoMasterComparativo(perfilamientoMaster = new PerfilamientoMaster()): Observable<PerfilamientoMasterComparativo> {
    return this.httpr.POST<PerfilamientoMasterComparativo>("/perfilamientoMaster/recupera-PerfilamientoMaster-Comparativo", perfilamientoMaster);
  }

  guardaProcesosPerfilamientoMaster(perfilamientoMaster = new PerfilamientoMaster()){
    return this.httpr.POST<PerfilamientoMasterProcesosSeguimiento>("/perfilamientoMaster/guarda-Procesos-PerfilamientoMaster", perfilamientoMaster);
  }

  guardaAsignacionPerfilamientoMaster(perfilamientoMaster = new PerfilamientoMaster()){
    return this.httpr.POST<PerfilamientoMaster>("/perfilamientoMaster/guardaAsignacionPerfilamientoMaster", perfilamientoMaster);
  }

  recuperaPerfilamientoMasterComentarios(perfilamientoMaster = new PerfilamientoMaster()){
    return this.httpr.POST<PerfilamientoMaster>("/perfilamientoMaster/recuperaPerfilamientoMaster", perfilamientoMaster);
  }
}
